import React from "react";
import dayjs from "dayjs";
import { DelayedIcon, DeliveredIcon, MoreDetailsIcon } from "asset/icons";
import { formatDate } from "../utils";
import { shipmentStatusList } from "constants/global";

const StatusTracking = ({ shipmentDetails, singleShipmentStatus }) => {
    return (
        <div className="p-4 bg-white group/list">
            <div className="relative pb-4 pl-6 group/item">
                <div className="box-border z-[12] absolute  border-3 border-white rounded-full -left-[10px] size-5">
                    <DeliveredIcon />
                </div>
                <div className="border-l h-[90%] absolute -left-[1px] top-[10%]"></div>
                <p className="text-base font-[450] text-main-dark">Booked</p>
                <p className="text-sm font-normal text-grey-10">
                    {formatDate(shipmentDetails.createdAt, "hh:mmA • MMM D, YYYY")}
                </p>
            </div>
            {singleShipmentStatus?.map((status, parentIndex) =>
                status?.status?.map((step, index) => {
                    const shipmentStatus = shipmentStatusList?.find(
                        (item) => item?.value === step?.status
                    )?.label;
                    return (
                        <div
                            key={index + shipmentStatus + parentIndex}
                            className="relative pb-4 pl-6 group"
                        >
                            <div className="box-border z-[12] absolute  border-3 border-white rounded-full -left-[10px] size-5">
                                {step.status == "Delayed" || step.status == "Cancelled" ? (
                                    <DelayedIcon />
                                ) : step.status == "Delivered" ? (
                                    <DeliveredIcon />
                                ) : (
                                    <div className="size-3 bg-[#11A811] rounded-full"></div>
                                )}
                            </div>
                            {/* {index !== status?.status.length - 1 && ( */}
                            <div className="group-last:hidden group-last:h-0 border-1 h-[90%] absolute -left-[1px] top-[10%]"></div>
                            {/* )} */}
                            <p className="text-base flex items-center font-[450] text-main-dark gap-x-4">
                                {shipmentStatus}{" "}
                                {step.status === "AtDeparturePort" ? (
                                    <span title="Package is ready for the harbour">
                                        <MoreDetailsIcon />
                                    </span>
                                ) : null}
                            </p>
                            {step?.remark && (
                                <p className="text-sm text-[#667085] italic">{step?.remark}</p>
                            )}
                            <p className="text-sm font-normal text-grey-10">
                                {dayjs(step?.date).format("hh:mmA • MMM D, YYYY")}
                            </p>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default StatusTracking;
